import React from "react";

const WaveDivider = ({ position = "bottom", color = "#ffffff", flip = false }) => {
  return (
    <div className={`wave-divider ${position}`} aria-hidden="true">
      <svg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        style={{ transform: flip ? "scaleY(-1)" : "none" }}
      >
        <path
          d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
